"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = global.cancelAnimationFrame || global.webkitCancelAnimationFrame || global.mozCancelAnimationFrame || global.oCancelAnimationFrame || global.msCancelAnimationFrame || global.clearTimeout;